module.exports = __webpack_public_path__ + "static/img/unipay.bd572d47.png";